import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { SectionTitle } from '../SectionTitle';
import { ProsAndConsList } from './ProsAndConsList';
import type { ProsAndConsProps } from './types';
export function ProsAndCons(t0) {
  const $ = _c(11);
  const {
    pros,
    cons
  } = t0;
  if (!pros.length && !cons.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      text: "Pros and Cons"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SectionTitle heading={t2} icon={{
      iconNode: <span aria-hidden="true" data-testid="section-title-icon" className="mask-icon mask-icon-thumbs-up-down-outlined" style={{
        width: "2rem",
        height: "2rem",
        backgroundColor: "#008254"
      }} />
    }} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      paddingTop: 1,
      gap: {
        xs: 3.5,
        sm: "none"
      },
      flexDirection: {
        xs: "column",
        sm: "row"
      },
      ml: {
        sm: 5
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== pros) {
    t5 = <ProsAndConsList title="Pros" listItems={pros} />;
    $[4] = pros;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cons) {
    t6 = <ProsAndConsList title="Cons" listItems={cons} />;
    $[6] = cons;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <Box sx={t1}>{t3}<Box sx={t4}>{t5}{t6}</Box></Box>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}